<template>
  <div v-if="card" class="bank-card" :style="{ backgroundImage: `url(${card.bg})` }">

    <div class="top">
      <img :src="card.icon" class="icon" v-if="card.icon" />
      <div class="bank-name">{{ card.bankName }}</div>
    </div>


    <div class="bottom">
      <div>
        <div class="number">{{ card.number }}</div>
        <div class="holder">{{ card.holder }}</div>
      </div>

      <img :src="card.qr" class="qr" v-if="card.qr" />
    </div>

  </div>
</template>

<script>
export default {
  props: ["raw"],

  data() {
    return {
      card: null
    };
  },

  mounted() {
    this.loadCard();
  },

  methods: {

    async loadCard() {

      try {
        const outer = JSON.parse(this.raw);
        const params = JSON.parse(outer.params);
        const url = params.pcItem?.data_url;

        if (!url) return;

        const res = await fetch(url);
        const html = await res.text();

        this.card = this.parseCard(html);

        console.log("Parsed card:", this.card);

      } catch (e) {
        console.error("Load error:", e);
      }

    },

    parseCard(html) {

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");

      const styleText = doc.querySelector("style")?.textContent || "";

      // ===== Lấy tất cả content:url(...) trong style =====
      const allUrls = [...styleText.matchAll(/content:\s*url\((.*?)\)/g)]
        .map(m => m[1]);

      let qr = "";
      let icon = "";

      allUrls.forEach(url => {
        if (url.includes("group-qr")) {
          qr = url;
        } else if (url.includes("res-zalo")) {
          icon = url;
        }
      });

      // ===== Background =====
      const bgMatch = styleText.match(/background:\s*url\((.*?)\)/);
      const bg = bgMatch?.[1] || "";

      // ===== Text =====
      const texts = [...doc.querySelectorAll("p")]
        .map(p => p.textContent.trim())
        .filter(Boolean);

      const bankName = texts.find(t => t.toLowerCase().includes("ngân hàng")) || "";

      const number =
        doc.querySelector(".number_text")?.textContent.trim() || "";

      const holder =
        texts.find(t => /^[A-Z\s]{5,}$/.test(t)) || "";

      return {
        bankName,
        number,
        holder,
        icon,
        qr,
        bg
      };
    }

  }
};
</script>

<style scoped>
.bank-card {
  width: 300px;
  height: 192px;
  padding: 16px;
  color: white;
  border-radius: 8px;
  background-size: cover;
  background-position: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: border-box;
}

.top {
  display: flex;
  align-items: center;
  gap: 8px;
}

.icon {
  width: 32px;
  height: 32px;
  border-radius: 6px;
}

.bank-name {
  font-size: 14px;
  opacity: 0.9;
}

.number {
  font-size: 20px;
  font-weight: bold;
  letter-spacing: 1px;
}

.bottom {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}

.holder {
  font-size: 14px;
  opacity: 0.85;
}

.qr {
  width: 80px;
  height: 80px;
  border-radius: 4px;
  object-fit: contain;
}
</style>